import { render, staticRenderFns } from "./TextDialog.vue?vue&type=template&id=0d345fe6&scoped=true"
import script from "./TextDialog.vue?vue&type=script&lang=js"
export * from "./TextDialog.vue?vue&type=script&lang=js"
import style0 from "./TextDialog.vue?vue&type=style&index=0&id=0d345fe6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d345fe6",
  null
  
)

export default component.exports